// src/api/request.js
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Message } from 'element-ui'

const request = axios.create({
  baseURL: '/api',
  timeout: 15000
})

// 登录态失效时可能多个请求同时返回 401（如订单列表同时拉活动、日志），
// 用这个开关避免重复弹窗、重复跳转（重复跳转会抛 NavigationDuplicated 导致红屏）。
let authRedirecting = false

request.interceptors.request.use(
  config => {
    if (store.state.auth.token) {
      config.headers.Authorization = 'Bearer ' + store.state.auth.token
    }
    return config
  },
  error => Promise.reject(error)
)

request.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 0) {
      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message))
    }
    return res
  },
  error => {
    if (error.response) {
      const { status, data } = error.response
      const requestUrl = String((error.config && error.config.url) || '')
      // 登录接口返回 401 表示「账号或密码错误」，不是登录过期，不能跳转也不能提示过期
      const isLoginRequest = requestUrl.indexOf('/auth/login') !== -1
      if (status === 401) {
        store.dispatch('auth/logout')
        if (isLoginRequest) {
          Message.error((data && data.message) || '用户名或密码错误')
        } else if (!authRedirecting && router.currentRoute.path !== '/login') {
          authRedirecting = true
          Message.error('登录已过期，请重新登录')
          router.push('/login').catch(() => {}).then(() => {
            setTimeout(() => { authRedirecting = false }, 800)
          })
        }
      } else {
        Message.error(data.message || '服务器错误')
      }
    } else {
      Message.error('网络连接失败')
    }
    return Promise.reject(error)
  }
)

export default request
